import { Tooltip, Typography } from '@mui/material';
import { memo, useMemo } from 'react';

type LabelWithTooltipProps = {
  label: string;
  tooltip?: string | null;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
  useBloxLabel?: boolean;
};

export const LabelWithTooltip = memo(
  ({
    label,
    tooltip,
    tooltipPlacement = 'top',
    useBloxLabel = false,
  }: LabelWithTooltipProps) => {
    const tooltipTxt = useMemo(() => {
      const text = tooltip || '';
      const cleaned = text.replace(/\s+/g, ' ').trim();
      return cleaned;
    }, [tooltip]);

    const dataTestId = useMemo(() => {
      if (!label || typeof label !== 'string' || label.trim() === '') {
        return 'label-tooltip-empty';
      }
      const nLabel = label.trim().toLowerCase().replace(/\s+/g, '-');
      return `label-tooltip-${nLabel}`;
    }, [label]);

    return (
      <Tooltip
        title={tooltipTxt}
        disableInteractive
        placement={tooltipPlacement}
      >
        {useBloxLabel ? (
          <Typography
            data-testid={dataTestId}
            variant="label"
            component="span"
            gutterBottom
          >
            {label}
          </Typography>
        ) : (
          <span data-testid={dataTestId}>{label}</span>
        )}
      </Tooltip>
    );
  },
);
LabelWithTooltip.displayName = 'LabelWithTooltip';
